import {Box, Button, Typography} from '@viptech/react-components'
import {useState} from 'react'
import usePostFeedback from 'src/hooks/api/events/usePostFeedback'
import imageErrorIcon from 'src/images/imageErrorIcon.svg'
import zoomInIcon from 'src/images/zoomInIcon.svg'
import ThumbsUpAndDown from 'src/pages/alarms/components/alarms-table/ThumbsUpAndDown'
import {SnapshotEvent} from '../../../../services/api'
import {ImageRenderResponsive} from '../styles'

type Props = {
  imageToRender: SnapshotEvent
  rowsLenght: number
  imageSelected: (image: SnapshotEvent) => void
  showFeedback: boolean
}

function ImageOnTable({imageToRender, rowsLenght, imageSelected, showFeedback}: Props) {
  const [imgFailed, setImgFailed] = useState(false)

  const {mutateAsync: sendFeedback} = usePostFeedback()
  const [isHoveringPhoto, setIsHoveringPhoto] = useState(false)

  const onMouseEnter = () => setIsHoveringPhoto(true)
  const onMouseLeave = () => setIsHoveringPhoto(false)
  return (
    <Box
      display='flex'
      align='center'
      justifyContent='center'
      direction='column'
      onMouseEnter={onMouseEnter}
      style={{position: 'relative'}}
      onMouseLeave={onMouseLeave}>
      {!imgFailed ? (
        <Box display='flex' align='center' columnGap='10px'>
          <ImageRenderResponsive
            rowsLenght={rowsLenght}
            src={`${process.env.REACT_APP_EVENT_IMAGES_BASE_URL}/${imageToRender.awsKey}`}
            alt=''
            onClick={(e) => imageSelected({...imageToRender, src: e.currentTarget.src})}
            onError={(e) => setImgFailed(true)}
            style={{boxShadow: isHoveringPhoto ? '0px 4px 8px #b4b4b4' : ''}}
          />

          {isHoveringPhoto && (
            <Box position='absolute' left={rowsLenght > 1 ? '23%' : '40%'} display='flex' align='center' justifyContent='center'>
              <img src={zoomInIcon} alt='zoom-in' width={20} height={16} style={{cursor: 'pointer'}} />
            </Box>
          )}

          {showFeedback && (
            <Box display='flex' direction='column' align='center' justifyContent='center' height='100%'>
              <Button
                variant='contained'
                color='transparent'
                hoverColor='#F5F5F5'
                height='50px'
                width='50px'
                onClick={() =>
                  sendFeedback({
                    eventId: imageToRender.eventId,
                    body: {
                      feedback: true,
                      imageId: imageToRender.id,
                    },
                  })
                }>
                <ThumbsUpAndDown transform='' />
              </Button>
              <Button
                variant='contained'
                color='transparent'
                hoverColor='#F5F5F5'
                height='50px'
                width='50px'
                onClick={() =>
                  sendFeedback({
                    eventId: imageToRender.eventId,
                    body: {
                      feedback: false,
                      imageId: imageToRender.id,
                    },
                  })
                }>
                <ThumbsUpAndDown transform='rotateX(180deg)' />
              </Button>
            </Box>
          )}
        </Box>
      ) : (
        <div>
          <img src={imageErrorIcon} alt='Icone de erro' height={'35px'} width={'50px'} />
          <Typography size='11px' variant='label' textAlign='center' color='#272727'>
            Falha ao carregar imagem
          </Typography>
        </div>
      )}
    </Box>
  )
}

export default ImageOnTable
